<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Customer Balance Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      current_date: moment(new Date()).format("DD-MM-YYYY"),
      id: atob(this.$route.params.id),
      totals:{
        totalin:0,
        totalout:0,
    },
    };
  },
  computed: {
    ...mapGetters("customers", [
        "CustomerBalanceDetails"
    ]),
  },
  methods: {
    ...mapActions({
        FetchBalanceDetails: "customers/fetchDescriptiveCustomerBalanceDetails",
    }),
  },

  watch: {
    CustomerBalanceDetails(newValue){
      if(newValue == true){
        this.FetchBalanceDetails();
      }
    }
  },

  updated() {
    let total_in = 0;
        let total_out = 0;
        if(this.CustomerBalanceDetails){
            this.CustomerBalanceDetails.forEach((item)=>{
                total_in = total_in+parseInt(item.amountIn);
            });
            this.totals.totalin = total_in;
            this.CustomerBalanceDetails.forEach((item)=>{
                total_out = total_out+parseInt(item.amountOut);
            });
            this.totals.totalout = total_out;

            setTimeout(() => {
                window.onafterprint = window.close;
                window.print();
                window.history.back();
            }, 2000)
        }
  },
  created() {
    this.FetchBalanceDetails(this.id);
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">

        <div class="bg-white p-2">
          <div class="print-font">

            <!-- Header with Logo and Business Info -->
            <div class="text-center mb-3" v-if="CustomerBalanceDetails.length">
              <img
                v-if="CustomerBalanceDetails[0].business2 && CustomerBalanceDetails[0].business2.Businesslogo"
                :src="CustomerBalanceDetails[0].business2.Businesslogo"
                height="80"
                class="mb-2"
              />
              <h3 class="text-uppercase">
                {{ CustomerBalanceDetails[0].business2 ? CustomerBalanceDetails[0].business2.name : '---' }}
              </h3>
              <p class="mb-1" style="font-size: 16px;">
                {{ CustomerBalanceDetails[0].business2 ? CustomerBalanceDetails[0].business2.address : '---' }}<br/>
                <strong>Tel: </strong>{{ CustomerBalanceDetails[0].business2 && CustomerBalanceDetails[0].business2.phone1 ? '+256' + CustomerBalanceDetails[0].business2.phone1 : '---' }}<br/>
                <strong>Email: </strong>{{ CustomerBalanceDetails[0].business2 ? CustomerBalanceDetails[0].business2.email : '---' }}
              </p>
            </div>

            <hr class="my-2" style="border-style: dashed;" />

            <!-- Report Title -->
            <h5 class="text-center fw-bold mb-3" style="font-family: Courier, monospace;" v-if="CustomerBalanceDetails.length">
              CUSTOMER PAYMENT REPORT<br/>
              FOR {{ CustomerBalanceDetails[0].customer ? CustomerBalanceDetails[0].customer.name.toUpperCase() : '---' }} - {{ CustomerBalanceDetails[0].customer ? CustomerBalanceDetails[0].customer.contact : '---' }}<br/>
              AS OF {{ current_date }}
            </h5>

            <!-- Table -->
            <div class="table-responsive">
              <table class="table table-striped table-bordered" style="font-size: 14px;">
                <thead class="table-light">
                  <tr>
                    <th>S/N</th>
                    <th>Amount Received</th>
                    <th>Amount In</th>
                    <th>Amount Out</th>
                    <th>Balance</th>
                    <th>Received Via</th>
                    <th>Description</th>
                    <th>Category</th>
                    <th>Recorded On</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(record, r) in CustomerBalanceDetails" :key="r">
                    <td>{{ r + 1 }}</td>
                    <td>{{ record.amount ? record.amount.toLocaleString() : 0 }}</td>
                    <td>{{ record.amountIn ? record.amountIn.toLocaleString() : 0 }}</td>
                    <td>{{ record.amountOut ? record.amountOut.toLocaleString() : 0 }}</td>
                    <td>{{ record.newbalance ? record.newbalance.toLocaleString() : 0 }}</td>
                    <td>{{ record.mode || '-' }}</td>
                    <td>{{ record.Description || '-' }}</td>
                    <td>{{ record.Category || '-' }}</td>
                    <td>{{ record.date || '-' }}</td>
                  </tr>
                  <tr v-if="CustomerBalanceDetails.length === 0">
                    <td colspan="9" class="text-center">
                      <b-spinner variant="primary" role="status"></b-spinner>
                      Loading...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Totals -->
            <div class="row text-center mt-3 g-2">
              <div class="col-12 col-md-4 mb-1">
                <h6>Total In: <span class="text-danger">{{ totals.totalin ? totals.totalin.toLocaleString() : 0 }}</span></h6>
              </div>
              <div class="col-12 col-md-4 mb-1">
                <h6>Total Out: <span class="text-danger">{{ totals.totalout ? totals.totalout.toLocaleString() : 0 }}</span></h6>
              </div>
              <div class="col-12 col-md-4 mb-1">
                <h6>Total Balance: <span class="text-danger">{{ (totals.totalin - totals.totalout) ? (totals.totalin - totals.totalout).toLocaleString() : 0 }}</span></h6>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>
